(function () {
    var selectors = [
        '.gh-content > p',
        '.gh-content > blockquote:not([class])',
        '.gh-content > ul',
        '.gh-content > ol',
        '.gh-content > dl',
        '.gh-content > h2',
        '.gh-content > h3',
        '.gh-content > h4',
        '.gh-content > h5',
        '.gh-content > h6',
        '.gh-content li',
        '.gh-content .kg-callout-card .kg-callout-text',
        '.gh-content .kg-toggle-card .kg-toggle-content > p',
        '.gh-content .kg-toggle-card .kg-toggle-content > ol',
        '.gh-content .kg-toggle-card .kg-toggle-content > ul',
        '.gh-content .kg-toggle-card .kg-toggle-heading-text',
        '.gh-content .kg-product-card .kg-product-card-description > p',
        '.gh-content .kg-product-card .kg-product-card-description > ol',
        '.gh-content .kg-product-card .kg-product-card-description > ul',
        '.gh-content figcaption'
    ];

    document.addEventListener('DOMContentLoaded', function () {
        selectors.forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (element) {
                if (element.closest('pre, .kg-code-card, code')) {
                    return;
                }

                element.setAttribute('dir', 'auto');
            });
        });
    });
})();
